import { graphql } from "gql";

const INTERNAL_ADMIN_ORGANIZATION_QUERY = graphql(`
  query InternalAdminOrganization($id: [ID!]!) {
    internalAdminOrganization(id: $id) {
      ...InternalAdminOrganization
    }
  }
`);

export default INTERNAL_ADMIN_ORGANIZATION_QUERY;
